import { shopPrefix } from '../../config';
import { http } from '../axios';
import { GroupingState } from '../../../models/GroupItem';

const url = `${shopPrefix}/v1/shoppingcart/:group/:id?`;
export function fetchCartGroupedItems(groupKey: string) {
    return http.get<GroupingState[]>(url, { pathParams: { group: groupKey } }).then(response => response.data);
}
